import React from 'react';
import { Shield, Ruler, Truck, CheckCircle2 } from 'lucide-react';
import { HOW_IT_WORKS, SERVICES } from '../../mock';

const WHY = [
  { icon: Shield, title: 'Siguranță înainte de toate', desc: 'Protecția lucrătorilor și a clienților, fără compromis, la fiecare montaj.' },
  { icon: Ruler, title: 'Precizie tehnică', desc: 'Procese standardizate și disciplină inginerească la fiecare etapă.' },
  { icon: CheckCircle2, title: 'Certificare UE', desc: 'Produse conforme EN 12810/12811, ISO 9001/14001/45001.' },
  { icon: Truck, title: 'Livrare 48h', desc: 'Stoc constant și livrare națională prin curier, direct la șantier.' },
];

export function WhyUs() {
  return (
    <section id="despre" className="py-20 md:py-28 bg-slate-50 border-y border-slate-200">
      <div className="egea-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <span className="section-eyebrow">Despre</span>
            <h2 className="font-display font-bold uppercase tracking-tight text-slate-900 text-3xl md:text-4xl leading-[1.05] mt-4">
              Inginerie locală.<br />Standard european.
            </h2>
            <p className="mt-6 text-base text-slate-600 leading-relaxed max-w-[480px]">
              EGEA fabrică schele și echipamente metalice din 1995. Producție internă în Brazi,
              echipe autorizate, certificare UE, fără verigi între tine și produs.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {WHY.map((w) => {
              const Icon = w.icon;
              return (
                <div key={w.title} className="card-hover border border-slate-200 bg-white p-6 shadow-sm">
                  <Icon size={22} className="text-[#f5a524] mb-4" />
                  <h3 className="font-display font-semibold text-slate-900 text-base mb-2">{w.title}</h3>
                  <p className="text-sm text-slate-500 leading-relaxed">{w.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export function HowItWorks() {
  return (
    <section id="servicii" className="py-20 md:py-28 bg-white">
      <div className="egea-container">
        <div className="max-w-[640px] mb-14">
          <span className="section-eyebrow">Cum funcționează</span>
          <h2 className="font-display font-bold uppercase tracking-tight text-slate-900 text-3xl md:text-4xl leading-[1.05] mt-4">
            De la prima schiță<br />până la montaj.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-16">
          {HOW_IT_WORKS.map((h) => (
            <div key={h.step} className="relative border border-slate-200 bg-slate-50 p-7 card-hover overflow-hidden">
              <div className="font-display font-black text-[64px] text-slate-100 leading-none absolute top-2 right-4 select-none">
                {h.step}
              </div>
              <div className="font-display font-bold text-[#f5a524] text-sm mb-4">{h.step}</div>
              <h3 className="font-display font-semibold text-slate-900 text-lg mb-3">{h.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed relative z-10">{h.desc}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-px bg-slate-200 border border-slate-200">
          {SERVICES.map((s) => (
            <div key={s.title} className="bg-white p-6 hover:bg-slate-50 transition-colors">
              <h4 className="font-display font-semibold text-slate-900 text-[15px] mb-1.5">{s.title}</h4>
              <p className="text-[12.5px] text-slate-500 leading-snug">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
